"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TicketShareExpirationEnum = exports.TicketFormatAsEnum = void 0;
var TicketFormatAsEnum;
(function (TicketFormatAsEnum) {
    TicketFormatAsEnum["Standard"] = "Standard";
    TicketFormatAsEnum["RCSC"] = "RCSC";
})(TicketFormatAsEnum = exports.TicketFormatAsEnum || (exports.TicketFormatAsEnum = {}));
var TicketShareExpirationEnum;
(function (TicketShareExpirationEnum) {
    TicketShareExpirationEnum["FortyEightHours"] = "48 hours";
    TicketShareExpirationEnum["NinetySixHours"] = "96 hours";
    TicketShareExpirationEnum["Never"] = "Never";
})(TicketShareExpirationEnum = exports.TicketShareExpirationEnum || (exports.TicketShareExpirationEnum = {}));
//# sourceMappingURL=IOrganization.js.map